import React from "react";
import { ToggleButton, ToggleButtonGroup } from "react-aria-components";
import { cn } from "tailwind-variants";
import { getConfigValue } from "../api/price";
import { useOfferCalculatorDispatch, useOfferCalculatorState } from "../context/OfferCalculatorContext";
import { getEnabledOptions, getPeriodDisplay } from "../utils/configHelpers";
function getContractPeriodGridClass(optionCount) {
    const base = "notranslate grid gap-2";
    if (optionCount <= 5) {
        const columnsByCount = {
            1: "grid-cols-1",
            2: "grid-cols-2",
            3: "grid-cols-3",
            4: "grid-cols-4",
            5: "grid-cols-5",
        };
        return `${base} ${columnsByCount[optionCount]}`;
    }
    if (optionCount === 6) {
        return `${base} grid-cols-3`;
    }
    return `${base} grid-cols-4`;
}
export default function ContractPeriodGrid() {
    const state = useOfferCalculatorState();
    const dispatch = useOfferCalculatorDispatch();
    const field = getConfigValue(state.config, "contract_period");
    const options = getEnabledOptions(field);
    if (!options.length) {
        return null;
    }
    return (<div className="config-group group-contract_period">
      <div className="mb-4 text-base font-medium leading-5">Okres umowy</div>
      <ToggleButtonGroup selectionMode="single" selectedKeys={state.contract_period ? new Set([state.contract_period]) : new Set()} onSelectionChange={(keys) => {
            const value = Array.from(keys)[0];
            if (value) {
                dispatch({
                    type: "set_param",
                    name: "contract_period",
                    value: String(value),
                });
            }
        }} className={getContractPeriodGridClass(options.length)}>
        {options.map((option) => {
            const { monthsLabel, yearsLabel } = getPeriodDisplay(option.key, option.label);
            return (<ToggleButton key={option.key} id={option.key} className={({ isSelected }) => {
                    var _a;
                    return (_a = cn("group flex flex-col items-center gap-1 rounded-lg border p-2 outline-none transition focus-visible:ring-2 focus-visible:ring-[#0071CE]", isSelected ? "border-[#0071CE] bg-[#ECF5FE]" : "border-[#DDE2E4]")) !== null && _a !== void 0 ? _a : "";
                }}>
              <span className="text-base font-normal leading-[2.2rem] text-[#020309] group-data-[selected]:font-bold group-data-[selected]:text-[#0071CE]">
                {monthsLabel}
              </span>
              <span className="text-xs font-normal leading-[1.4rem] tracking-wide text-[#66676C] group-data-[selected]:text-[#0071CE]">
                {yearsLabel}
              </span>
            </ToggleButton>);
        })}
      </ToggleButtonGroup>
    </div>);
}
